
import { useCallback } from 'react';
import { Attendee } from '@/types/attendee';
import { useAdminAttendance } from '@/hooks/useAdminAttendance';
import { useToast } from '@/hooks/use-toast';

/**
 * Hook for managing attendance-related activities on the Admin page
 * Passing refreshAttendees as the 4th parameter to ensure timely data updates
 */
export const useAdminPageAttendance = (
  attendees: Attendee[],
  recordAction: (actionType: string, adminName: string, details?: string, attendeeCode?: string) => void,
  adminName: string,
  refreshAttendees: () => Promise<Attendee[]>
) => {
  const { toast } = useToast();
  
  // Use useAdminAttendance hook
  const {
    selectedAttendee,
    isDialogOpen,
    setIsDialogOpen,
    isConfirming,
    handleQrScan,
    handleCodeSubmit,
    confirmAttendance,
    simulateQrScan
  } = useAdminAttendance(
    attendees,
    recordAction,
    adminName,
    { toast },
    refreshAttendees
  );
  
  return {
    selectedAttendee,
    isDialogOpen,
    setIsDialogOpen,
    isConfirming,
    handleQrScan,
    handleCodeSubmit,
    confirmAttendance,
    simulateQrScan
  };
};
